module.exports = __webpack_public_path__ + "static/snow-report-panel-da11a4389a0bd26139663148c1cc2548.jpg";